/* WISHLIST TRANSLATIONS */

document.querySelector('.titletext').innerHTML = window.i18n.wishlist['title'];
document.querySelector('.sharebutton').innerHTML = window.i18n.wishlist['share'];
document.querySelector('.clearall').innerHTML = window.i18n.wishlist['clear_all'];
document.querySelector('#addallbutton').innerHTML = window.i18n.wishlist['add_all'];
document.onreadystatechange = function () {
  if (document.readyState == "complete") {
    var productATCButtons = document.querySelectorAll('.product .addsingleproduct');
    var productRemoveButtons = document.querySelectorAll('.product .removebutton');
    productATCButtons.forEach(function (productATCButton) {
      productATCButton.innerHTML = window.i18n.wishlist['add_to_cart'];
    });
    productRemoveButtons.forEach(function (productRemoveButton) {
      productRemoveButton.innerHTML = window.i18n.wishlist['remove'];
    });
    document.querySelector('.alert.alert-info.empty-wishlist').innerHTML = window.i18n.wishlist['empty_wishlist'];
  }
};